import { HStack, Icon } from "@chakra-ui/react";
import type { ComponentProps } from "react";
import React from "react";
import {
  FaBiking,
  FaHiking,
  FaMountain,
  FaQuestion,
  FaRunning,
  FaSkiing,
  FaSkiingNordic,
  FaSwimmer,
} from "react-icons/fa";
import { GiFootprint } from "react-icons/gi";

interface ISportIconsFactory extends ComponentProps<any> {
  id?: string;
}

const SportIconsFactory = ({ id, ...props }: ISportIconsFactory) => {
  switch (id) {
    case "icon-running":
      return <Icon as={FaRunning} {...props} />;
    case "icon-cycling":
      return <Icon as={FaBiking} {...props} />;
    case "icon-trail":
      return (
        <HStack spacing={0} {...props} align="center" justify="center">
          <Icon as={FaRunning} {...props} flex={1} />
          <Icon as={FaMountain} {...props} flex={1} />
        </HStack>
      );
    case "icon-trek":
      return <Icon as={FaHiking} {...props} />;
    case "icon-ski":
      return <Icon as={FaSkiingNordic} {...props} />;
    case "icon-swimming":
      return <Icon as={FaSwimmer} {...props} />;
    case "icon-vertical-ski":
      return <Icon as={FaSkiing} {...props} />;
    case "icon-bfr":
      return (
        <HStack spacing={0} {...props} align="center" justify="center">
          <Icon as={FaRunning} {...props} flex={1} />
          <Icon as={GiFootprint} {...props} flex={1} />
        </HStack>
      );

    default:
      return <Icon as={FaQuestion} {...props} />;
  }
};

export default SportIconsFactory;
